/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Sobota`
};

const da_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Lørdag`
};

const de_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Samstag`
};

const en_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Saturday`
};

const es_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Sábado`
};

const fr_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Samedi`
};

const hu_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Szombat`
};

const it_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Sabato`
};

const nl_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Zaterdag`
};

const pl_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Sobota`
};

const pt_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Sábado`
};

const sv_weekdays_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Lördag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_saturday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_saturday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_saturday", locale)
	if (locale === "cs") return cs_weekdays_saturday(inputs)
	if (locale === "da") return da_weekdays_saturday(inputs)
	if (locale === "de") return de_weekdays_saturday(inputs)
	if (locale === "en") return en_weekdays_saturday(inputs)
	if (locale === "es") return es_weekdays_saturday(inputs)
	if (locale === "fr") return fr_weekdays_saturday(inputs)
	if (locale === "hu") return hu_weekdays_saturday(inputs)
	if (locale === "it") return it_weekdays_saturday(inputs)
	if (locale === "nl") return nl_weekdays_saturday(inputs)
	if (locale === "pl") return pl_weekdays_saturday(inputs)
	if (locale === "pt") return pt_weekdays_saturday(inputs)
	return sv_weekdays_saturday(inputs)
};
export { weekdays_saturday as "weekdays.saturday" }